var Ostrovok = (function ($) {

    Ostrovok = function () {
        var that = this;
    };

    Ostrovok.prototype.getOstrovokLink = function (data = []) {
        var that = this,
            ostrovok_url = new URL('https://ostrovok.ru/hotels/');

        ostrovok_url.search = new URLSearchParams({
            q: data.ostrovok_id,
            cur: data.currency,
            dates: that.__getOstrovokDates(data.departure_date, data.arrival_date),
            guests: that.__getOstrovokGuests(data.passengers),
            lang: data.lang,
            partner_slug: data.partner_slug,
            utm_campaign: data.utm_campaign,
            utm_medium: data.utm_medium,
            utm_source: data.utm_source,
            utm_term: data.utm_term,
            partner_extra: data.partner_extra,
            sid: data.sid,
        });

        return ostrovok_url.href;
    };

    Ostrovok.prototype.__getOstrovokDates = function (departure_date, arrival_date = null) {
        var date_format = 'DD.MM.YYYY';
        arrival_date = arrival_date ? dayjs(arrival_date).format(date_format) : dayjs(departure_date).add(1, 'day').format(date_format);
        departure_date = dayjs(departure_date).format(date_format);

        return `${departure_date}-${arrival_date}`;
    };

    // Формирует параметр `Количество гостей` (guests) для подстановки в url 
    // формат `AandX.Y.Z.Q`, где:
    // A – общее количество взрослых (включая пенсионеров [YHT] и молодёжь [SRC]),
    // после `and` должен идти список возрастов детей через точку (максимум 4 значения)
    // X – возраст первого ребенка, 
    // Y – возраст второго ребенка, 
    // Z – возраст третьего ребенка 
    // Q - возраст четвертого ребенка 
    Ostrovok.prototype.__getOstrovokGuests = function (passengers) {
        var adult_categories = ['ADT', 'YTH', 'SRC'],
            child_categories = {
                CHD: 7, // задаём значение возраста по умолчанию для детей - 7 лет
                CNN: 7, // задаём значение возраста по умолчанию для детей - 7 лет
                INF: 1, // для младенцев - 1 год
                INS: 1 // для младенцев - 1 год
            },
            adults_count = 0,
            childs = [];

        adult_categories.forEach(function (adult_category) {
            adults_count += passengers[adult_category];
        });

        for (var category in child_categories) {
            var count = passengers[category];

            while (count > 0) {
                childs.push(child_categories[category]);
                count--;
            }
        }

        var sliced_childs = childs.slice(0, 4);
        return sliced_childs.length === 0 ? adults_count : adults_count + 'and' + sliced_childs.join('.');
    };

    Ostrovok.prototype.applyOstrovokToButton = function ($button, data = []) {
        var that = this,
            ostrovok_link = that.getOstrovokLink(data);

        $button.on('click', function() {
            if (ostrovok_link) {
                window.location.href = ostrovok_link;
            }
        });
    }

    return Ostrovok;

})($);